export enum ConnectorStatus {
  AVAILABLE = 'AVAILABLE',
  SESSION = 'SESSION',
  UNKNOWN = 'UNKNOWN',
  UNAVAILABLE = 'UNAVAILABLE',
}
